import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { LoginForm } from "../components/login-form";
import { SignupForm } from "../components/signup-form";

export default function Login() {
  const { user, loading, signInWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [signingIn, setSigningIn] = useState(false);
  const [isSignup, setIsSignup] = useState(location.state?.signup === true);

  useEffect(() => {
    if (!loading && user) navigate("/practice", { replace: true });
  }, [user, loading, navigate]);

  const handleGoogle = async () => {
    setSigningIn(true);
    try {
      await signInWithGoogle();
      navigate("/practice", { replace: true });
    } catch (err) {
      toast.error(err?.message || "Sign-in failed");
    } finally {
      setSigningIn(false);
    }
  };

  if (loading) return null;

  return (
    <div className="flex min-h-screen w-full items-center justify-center p-6 md:p-10" style={{ background: "hsl(var(--background))" }}>
      <div className="w-full max-w-sm">
        {isSignup ? (
          <SignupForm
            onGoogleLogin={handleGoogle}
            signingIn={signingIn}
            onSwitchToLogin={() => setIsSignup(false)}
          />
        ) : (
          <LoginForm
            onGoogleLogin={handleGoogle}
            signingIn={signingIn}
            onSwitchToSignup={() => setIsSignup(true)}
          />
        )}
      </div>
    </div>
  );
}
